// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"e8cf43da","518":"d8ed3f4c"}[chunkId] + ".chunk.css";
};